// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__Zt8QM {
  position: relative;
  background-color: var(--background-color-2);
  width: 100%;
}
.Footer_footer__Zt8QM .Footer_footer__top__8knHh {
  border-top: 1px solid var(--light-grey);
}
.Footer_footer__Zt8QM .Footer_footer__top__container__ByTns {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 56px;
  padding-bottom: 56px;
}
.Footer_footer__Zt8QM .Footer_footer__top--title__Eh7Lu {
  font-size: 16px;
  font-weight: 600;
}
.Footer_footer__Zt8QM .Footer_footer__top--btn-group__Y2Q9d {
  display: flex;
  gap: 32px;
}
.Footer_footer__Zt8QM .Footer_footer__top--button__O8sRd {
  width: 100%;
  border-color: var(--light-grey);
  border-radius: 8px;
  padding: 24px;
  gap: 12px;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--link-wrapper__Hxfp9 {
  flex: 1 1;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--link-wrapper__Hxfp9 a {
  width: 100%;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--logo__qpWDw img {
  height: 48px;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--text__rq7vc {
  display: flex;
  flex-direction: column;
  text-transform: initial;
  gap: 4px;
  text-align: start;
  line-height: normal;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--text--title__K2H5q {
  font-size: 16px;
  color: black;
  font-weight: 600;
}
.Footer_footer__Zt8QM .Footer_footer__top--button--text--subtitle__nV6Gb {
  font-size: 14px;
  color: var(--dark-grey);
}
.Footer_footer__Zt8QM .Footer_footer__top--button__O8sRd svg {
  margin-left: auto;
  fill: var(--dark-grey);
}
.Footer_footer__Zt8QM .Footer_footer__bottom__BOgkf {
  border-top: 1px solid var(--light-grey);
}
.Footer_footer__Zt8QM .Footer_footer__bottom__container__QxwK0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
}
.Footer_footer__Zt8QM .Footer_footer__bottom__left__o7PAk {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;
}
.Footer_footer__Zt8QM .Footer_footer__bottom__left__o7PAk .Footer_logo__3G2ik img {
  height: 48px;
}
.Footer_footer__Zt8QM .Footer_footer__bottom__right__0XlRd {
  display: flex;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
}
.Footer_footer__Zt8QM .Footer_text__tjjEm {
  font-weight: 500;
  line-height: 16px;
  color: var(--dark-grey);
  opacity: 0.8;
  transition: all 0.3s ease;
}
.Footer_footer__Zt8QM .Footer_text__tjjEm.Footer_highlight__YeG44 {
  color: var(--accent-color);
}
.Footer_footer__Zt8QM .Footer_text__tjjEm:hover {
  opacity: 1;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .Footer_footer__Zt8QM .Footer_footer__top--btn-group__Y2Q9d {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Footer/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,2CAAA;EACA,WAAA;AACF;AAEI;EACE,uCAAA;AAAN;AAEM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AAAR;AAGM;EACE,eAAA;EACA,gBAAA;AADR;AAIM;EACE,aAAA;EACA,SAAA;AAFR;AAKM;EACE,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAHR;AAKQ;EACE,SAAA;AAHV;AAKU;EACE,WAAA;AAHZ;AAQU;EACE,YAAA;AANZ;AAUQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AARV;AAUU;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AARZ;AAWU;EACE,eAAA;EACA,uBAAA;AATZ;AAaQ;EACE,iBAAA;EACA,sBAAA;AAXV;AAgBI;EACE,uCAAA;AAdN;AAgBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AAdR;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAfR;AAkBU;EACE,YAAA;AAhBZ;AAqBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAnBR;AAwBE;EACE,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;AAtBJ;AAwBI;EACE,0BAAA;AAtBN;AAyBI;EACE,UAAA;EACA,eAAA;AAvBN;AA2BE;EAGM;IACE,sBAAA;EA3BR;AACF","sourcesContent":[".footer {\n  position: relative;\n  background-color: var(--background-color-2);\n  width: 100%;\n\n  .footer {\n    &__top {\n      border-top: 1px solid var(--light-grey);\n\n      &__container {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n        padding-top: 56px;\n        padding-bottom: 56px;\n      }\n\n      &--title {\n        font-size: 16px;\n        font-weight: 600;\n      }\n\n      &--btn-group {\n        display: flex;\n        gap: 32px;\n      }\n\n      &--button {\n        width: 100%;\n        border-color: var(--light-grey);\n        border-radius: 8px;\n        padding: 24px;\n        gap: 12px;\n\n        &--link-wrapper {\n          flex: 1;\n\n          a {\n            width: 100%;\n          }\n        }\n\n        &--logo {\n          img {\n            height: 48px;\n          }\n        }\n\n        &--text {\n          display: flex;\n          flex-direction: column;\n          text-transform: initial;\n          gap: 4px;\n          text-align: start;\n          line-height: normal;\n\n          &--title {\n            font-size: 16px;\n            color: black;\n            font-weight: 600;\n          }\n\n          &--subtitle {\n            font-size: 14px;\n            color: var(--dark-grey);\n          }\n        }\n\n        svg {\n          margin-left: auto;\n          fill: var(--dark-grey);\n        }\n      }\n    }\n\n    &__bottom {\n      border-top: 1px solid var(--light-grey);\n\n      &__container {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 40px;\n        padding-top: 40px;\n        padding-bottom: 40px;\n      }\n\n      &__left {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 32px;\n\n        .logo {\n          img {\n            height: 48px;\n          }\n        }\n      }\n\n      &__right {\n        display: flex;\n        align-items: center;\n        gap: 32px;\n        flex-wrap: wrap;\n      }\n    }\n  }\n\n  .text {\n    font-weight: 500;\n    line-height: 16px;\n    color: var(--dark-grey);\n    opacity: 0.8;\n    transition: all 0.3s ease;\n\n    &.highlight {\n      color: var(--accent-color);\n    }\n\n    &:hover {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .footer {\n      &__top {\n        &--btn-group {\n          flex-direction: column;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__Zt8QM`,
	"footer__top": `Footer_footer__top__8knHh`,
	"footer__top__container": `Footer_footer__top__container__ByTns`,
	"footer__top--title": `Footer_footer__top--title__Eh7Lu`,
	"footer__top--btn-group": `Footer_footer__top--btn-group__Y2Q9d`,
	"footer__top--button": `Footer_footer__top--button__O8sRd`,
	"footer__top--button--link-wrapper": `Footer_footer__top--button--link-wrapper__Hxfp9`,
	"footer__top--button--logo": `Footer_footer__top--button--logo__qpWDw`,
	"footer__top--button--text": `Footer_footer__top--button--text__rq7vc`,
	"footer__top--button--text--title": `Footer_footer__top--button--text--title__K2H5q`,
	"footer__top--button--text--subtitle": `Footer_footer__top--button--text--subtitle__nV6Gb`,
	"footer__bottom": `Footer_footer__bottom__BOgkf`,
	"footer__bottom__container": `Footer_footer__bottom__container__QxwK0`,
	"footer__bottom__left": `Footer_footer__bottom__left__o7PAk`,
	"logo": `Footer_logo__3G2ik`,
	"footer__bottom__right": `Footer_footer__bottom__right__0XlRd`,
	"text": `Footer_text__tjjEm`,
	"highlight": `Footer_highlight__YeG44`
};
export default ___CSS_LOADER_EXPORT___;
